
import PIXI from '../GameEngine/pixi.js';

export default class LoadScene extends PIXI.Container {
    constructor(app) {
        super();
        this.app = app;
        //this.paused = true;
        this.stageWidth = 800;
        this.stageHeight = 500;
        this.isLoaded = false;
    }
    init() {

    }
    preload(loader) {

    }
    create() {
        if (this.isLoaded) return;
        this.isLoaded = true;

        // //Title
        // var title = new PIXI.Sprite(PIXI.Loader.shared.resources['Title'].texture);
        // title.width = 600;
        // title.height = 110;
        // title.x = 400;
        // title.y = 15;
        // title.anchor.set(0.5, 0);
        // this.addChild(title);



        var useCache = false;
        this.cacheAsBitmap = useCache;
        this.isDirty = true;
    }
    update() {
 
    }
    render() {
        this.isDirty = false;
    }
    shutdown() {
     
    }

    postLoaded() {

    }
    
}